import ConnectWallet from '../pages/connect-wallet'
import { RefreshCcw } from 'lucide-react'

export default {
	icon: RefreshCcw,
	name: 'Switch Wallet',
	component: ConnectWallet,
	featured: true,
	filter: ({ loggedIn }: any) => {
		return loggedIn
	}
}
